import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-client-attribution-fees',
  templateUrl: './client-attribution-fees.component.html',
  styleUrls: ['./client-attribution-fees.component.scss']
})
export class ClientAttributionFeesComponent implements OnInit {
  @Output() step_change = new EventEmitter<any>();
  @Input() step_input: any;

  isEdit: boolean = false;
  client_id;
  client: string;
  editPermission: boolean = true;

  vdsp_off_commission_data;
  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.client = this.step_input.client;
    this.editPermission = this.step_input.editPermission;
    this.client_id = this.route.snapshot.paramMap.get("id");
    this.isEdit = this.step_input.isEdit || false;
    this.vdsp_off_commission_data = this.step_input.vdsp_off_commission;
  }

  cancel() {
    this.commonService.goToLandingPage(this.client == 'agency' ?'/agency':'/advertiser');
  }

  proceed() {
      this.step_change.emit({
        'procced': true
      });
  }

  back() {
    this.step_change.emit({
      "previous": true
    });
  }
}
